<ion-content scroll-y="false">
  <div class="splash">
    <img src="../../assets/images/logo-splash.svg">
  </div>
</ion-content>
